// Base_Url
// export const API_URL = process.env.REACT_APP_API_URL
// export const API_URL = "http://localhost:5000/api/";
export const API_URL = "https://backend.ar-e-cart.com/api/";
